import { IOption } from "../interfaces/option.interface";

export const searchOption = (needle: string, haystack: IOption[]): IOption[] =>
  haystack.filter(({ value }) =>
    value.toString().toLowerCase().includes(needle.toLowerCase())
  );
